/**
 * Demo Module Mutation Types
 * Constants for all demo-related mutations
 */

export const DEMO_START = 'DEMO_START';
export const DEMO_END = 'DEMO_END';
export const DEMO_CLOSE = 'DEMO_CLOSE';
export const DEMO_RESET = 'DEMO_RESET';

export const SET_CURRENT_STEP = 'SET_CURRENT_STEP';
export const NEXT_STEP = 'NEXT_STEP';
export const PREVIOUS_STEP = 'PREVIOUS_STEP';

export const MARK_STEP_COMPLETE = 'MARK_STEP_COMPLETE';
export const MARK_STEPS_COMPLETE = 'MARK_STEPS_COMPLETE';

export const SET_DEMO_STATUS = 'SET_DEMO_STATUS';
export const SET_DEMO_ACTIVE = 'SET_DEMO_ACTIVE';
export const SET_DEMO_PAUSED = 'SET_DEMO_PAUSED';

export const SET_START_TIME = 'SET_START_TIME';
export const SET_END_TIME = 'SET_END_TIME';

export default {
  DEMO_START,
  DEMO_END,
  DEMO_CLOSE,
  DEMO_RESET,
  SET_CURRENT_STEP,
  NEXT_STEP,
  PREVIOUS_STEP,
  MARK_STEP_COMPLETE,
  MARK_STEPS_COMPLETE,
  SET_DEMO_STATUS,
  SET_DEMO_ACTIVE,
  SET_DEMO_PAUSED,
  SET_START_TIME,
  SET_END_TIME,
};
